import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ContentContext = createContext({ content: {}, get: (_p, fb) => fb, loaded: false });

const readPath = (obj, path) => {
  if (!obj) return undefined;
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/content")
      .then((r) => setContent(r.data || {}))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  // get("home.hero.title1", "Fallback") — geeft fallback als de tekst ontbreekt
  const get = useCallback((path, fallback) => {
    const v = readPath(content, path);
    return v === undefined || v === null || v === "" ? fallback : v;
  }, [content]);

  return (
    <ContentContext.Provider value={{ content, get, loaded }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
